import { useEffect, useState } from 'react';

import { Typography } from '@mui/material';

import { AnimationBg, Section, StaticSvgContainer } from './styled';
import { CardProps } from './types';
import { loadAnimation, mapSectionToLink, mapSectionToStaticSvg, mapSectionToTitle } from './utils';

function Card({ section }: CardProps) {
  const [hovered, setHovered] = useState(false);
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    if (hovered) {
      loadAnimation(section, setAnimationData);
    }
  }, [hovered, section]);

  const StaticSvg = mapSectionToStaticSvg[section];

  return (
    // @ts-ignore
    <Section
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      target="_blank"
      href={mapSectionToLink[section]}
    >
      {animationData ? (
        <AnimationBg animationData={animationData} play={hovered} />
      ) : (
        <StaticSvgContainer>
          <StaticSvg />
        </StaticSvgContainer>
      )}
      <Typography variant="subtitle2" sx={{ position: 'relative', zIndex: 1 }}>
        {mapSectionToTitle[section]}
      </Typography>
    </Section>
  );
}

export default Card;
